import React, { useEffect, useState } from 'react';
import { BsXLg } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import placeholder from '../../../../assets/images/placeholder.png';
import { axiosInstance } from '../../../../config/axiosInstance';
import RemoveModal from '../../../Utils/Components/removeModal';
import LazyImage from '../../../Utils/Components/imageComponent';
import { AiFillSketchSquare, AiFillStar, AiOutlineStar } from 'react-icons/ai';

export type singleImageProps = {
	topicId: string;
	item: any;
	isMine: boolean;
	images: any[];
	setImages: (images: any[]) => void;
	extensionImages?: any[];
	setExtensionImages?: (extensionImages: any[]) => void;
	setIsChanged: (isChanged: boolean) => void;

	reloadCount: number;
	setReloadCount: (count: number) => void;

	setEditImageModalOpen?: (isOpen: boolean) => void;
	setEditImageModalId?: (imageId: string) => void;
	isForPhone: boolean;
	setCoverPic: (imageUrl: string) => void;
	dailyImageId?: string;
};

export const BackgroundImage = ({
	item,
	topicId,
	isMine,
	images,
	setImages,
	reloadCount,
	setReloadCount,

	setEditImageModalId,
	setEditImageModalOpen,
	isForPhone,
	setCoverPic,
	setIsChanged,

	extensionImages,
	setExtensionImages,
	dailyImageId
}: singleImageProps) => {
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
	const [isSelectedForExtension, setIsSelectedForExtension] = useState(false);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const dispatch = useDispatch();

	// const { width } = useTypedSelector((state) => state.global);

	interface IDeleteImage {
		topicId: string;
		imageId: string;
	}

	const removeImageReq = async (data: IDeleteImage) => {
		const params = new URLSearchParams();
		params.append('mediaId', data.imageId);
		params.append('topicId', data.topicId);

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + '/admin/topic/delete-image',
			params,
			config
		);
		return response;
	};

	const updateCoverPicReq = async () => {
		const dto = {
			imageId: item._id,
			topicId: topicId,
			isPhone: isForPhone
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + '/admin/topic/update-coverpic',
			dto,
			config
		);
		return response;
	};

	const updateCoverPicMutation = useMutation(updateCoverPicReq, {
		onSuccess: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: "Successfully updated topic's cover picture."
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't update topic's cover picture."
				})
			);
		}
	});

	const { mutate } = useMutation(removeImageReq, {
		onSuccess: () => {
			setImages(images.filter((image) => image._id != item._id));
			setReloadCount(reloadCount + 1);

			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted image from topic.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete image from topic."
				})
			);
		}
	});

	const removeImage = (topicId: string, imageId: string) => {
		mutate({ topicId, imageId });
	};

	const updateCoverImage = () => {
		updateCoverPicMutation.mutate();
	};

	const navigate = useNavigate();
	const accessImage = () => {
		if (setEditImageModalOpen && setEditImageModalId) {
			setEditImageModalOpen(true);
			setEditImageModalId(item._id);
		} else {
			if (isForPhone) navigate(`phone-image/${item._id}`);
			else navigate(`image/${item._id}`);
		}
	};

	const addImageToExtension = (id: string) => {
		if (setExtensionImages != null && extensionImages != null) {
			const extensionImagesCopy = extensionImages.slice();
			extensionImagesCopy.push(id);
			setExtensionImages(extensionImagesCopy);
			setIsChanged(true);
		}
	};
	const removeImageFromExtension = (id: string) => {
		if (setExtensionImages != null && extensionImages != null) {
			const extensionImagesCopy = extensionImages.slice();
			const index = extensionImagesCopy.findIndex((image) => image == id);
			extensionImagesCopy.splice(index, 1);
			setExtensionImages(extensionImagesCopy);
			setIsChanged(true);
		}
	};

	useEffect(() => {
		if (extensionImages?.includes(item._id)) setIsSelectedForExtension(true);
		else setIsSelectedForExtension(false);
	}, [extensionImages]);

	return (
		<div
			className={`flex flex-wrap flex-col p-4 cursor-pointer ${
				isForPhone ? ' w-1/6' : ' w-1/3'
			}`}
			onClick={() => {
				if (isMine) accessImage();
			}}
		>
			<div>
				<RemoveModal
					title={'Remove Image'}
					text={'Are you sure you want to remove this image?'}
					setModalOpen={setIsRemoveModalOpen}
					setAction={() => removeImage(topicId, item._id)}
					visible={isRemoveModalOpen}
				/>
			</div>
			<div
				className={`relative rounded-lg flex justify-center content-center w-full
						dark:bg-gray-600 bg-gray-300 mb-2 group ${
							isForPhone ? 'aspect-[10/18]' : 'aspect-[16/10]'
						}`}
			>
				<LazyImage
					photo={item.url_low_res != null ? item.url_low_res : placeholder}
					style={`block object-cover object-center w-full rounded-lg  ${
						isForPhone ? 'aspect-[10/18]' : 'aspect-[16/10] max-h-[240px]'
					}`}
					placeholderStyle={
						'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
					}
					loaderDimesnions={70}
				/>

				{dailyImageId && item._id === dailyImageId && (
					<span className="absolute top-2 left-2 badge badge-sm badge-success shadow-md z-10">
						Daily
					</span>
				)}

				<>
					<button className="absolute top-2 right-2 btn-primary btn-xs btn btn-circle btn-outline shadow-md">
						{isSelectedForExtension ? <AiFillStar /> : <AiOutlineStar />}
					</button>
				</>

				<div
					className="absolute inset-0 bg-gradient-to-t rounded-lg
							from-black/75 opacity-0 group-hover:opacity-100 transition-all duration-500 text-center"
				>
					{isMine && (
						<>
							<div className="group-1">
								<button
									className="absolute top-2 left-2 btn-error btn-xs btn btn-circle btn-outline shadow-md"
									onClick={(e) => {
										if (images.length > 0) {
											e.stopPropagation();
											setIsRemoveModalOpen(true);
										}
									}}
								>
									<BsXLg />
								</button>
								<span
									className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
											scale-0 origin-left group-1-hover:scale-100
						              		font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 left-10 z-50"
								>
									{images.length <= 0 ? "Can't remove 🚫" : 'Remove ❌'}
								</span>
							</div>

							{item.url_low_res != null && (
								<div>
									<div className="group-1">
										<button
											className="absolute top-2 right-2 btn-primary btn-xs btn btn-circle btn-outline shadow-md"
											onClick={(e) => {
												e.stopPropagation();
												isSelectedForExtension
													? removeImageFromExtension(item._id)
													: addImageToExtension(item._id);
											}}
										>
											{isSelectedForExtension ? (
												<AiFillStar />
											) : (
												<AiOutlineStar />
											)}
										</button>
										<span
											className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
											scale-0 origin-left group-1-hover:scale-100
						              		font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 -right-36 mr-2 z-50"
										>
											{'Set extension picture'}
										</span>
									</div>
									<div className="group-1">
										<button
											className="absolute top-2 right-10 btn-warning btn-xs btn btn-circle btn-outline shadow-md"
											onClick={(e) => {
												e.stopPropagation();
												setCoverPic(item.url);
												updateCoverImage();
											}}
										>
											<AiFillSketchSquare />
										</button>
										<span
											className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
											scale-0 origin-left group-1-hover:scale-100
						              		font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 -right-20 mr-2 z-50"
										>
											{'Set cover picture'}
										</span>
									</div>
								</div>
							)}
						</>
					)}
				</div>
				{/* {item.isComplete || (
					<div className="group-1 absolute top-1 left-0">
						<button className="absolute top-1 left-2 btn-warning btn-xs btn btn-circle btn-outline shadow-md transform group-hover:translate-x-8">
							<BsExclamationTriangleFill />
						</button>
						<span
							className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs z-10
									  scale-0 origin-left group-1-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-0 left-18"
						>
							{'Image is missing a title❗'}
						</span>
					</div>
				)} */}
			</div>
			<h3 className="mx-auto text-gray-700 dark:text-gray-200 font-semibold">
				{item.title}
			</h3>
		</div>
	);
};
